/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { useState } from "react"
import { useLocation } from "react-router-dom"
import {
  TravelersListDataType,
  TravelersSearchConditionType,
} from "../../../../models/list"
import { useExportFile } from "../useExportFile"
import { useTravelersRouters } from "../useRouters"
import { useRowSelection } from "../useRowSelection"
import { useTableConfig } from "../useTableConfig"
import { useVariablesAuthority } from "../useVariablesAuthority"
import { getBreadcrumbItems } from "./getBreadcrumbItems"
import { TravelersListDataSourceType } from "../../../../models/list/data"
import { Form } from "antd"
import { OptionItemType } from "../../../../../../../_webui/layout/components/Select/models"
import { getCities } from "../../../../../../../utils/apis/getCities"
import { TravelerFormSearchFormDataType } from "../../../../components/list/FormSearch/modals"

export const useVariables = () => {
  const { pathname, state } = useLocation<TravelersSearchConditionType>()
  const [form] = Form.useForm<TravelerFormSearchFormDataType>()

  const {
    isHiddenBtnDelete,
    isHiddenBtnExportFile,
    isHiddenBtnRefer,
    isHiddenBtnRegister,
    isHiddenBtnRequestDelete,
    isNotAccessScreen,
    isPathnameTravelers,
    isPathnameTravelersUser,
    isPathnameTravelersUserSearch,
  } = useVariablesAuthority()
  const { columns } = useTableConfig()
  const [isOtherCity, setIsOtherCity] = useState(false)
  const [isOverseasResident, setIsOverseasResident] = useState(false)
  const [isLoadingLayout, setIsLoadingLayout] = useState(true)
  const [travelerInfo, setTravelerInfo] = useState<
    TravelersListDataSourceType[]
  >([])
  const [dataSourceExport, setDataSourceExport] = useState<
    TravelersListDataType[]
  >([])
  const [searchCondition, setSearchCondition] =
    useState<TravelerFormSearchFormDataType>({ ...state?.searchCondition })
  const [allCountries, setAllCountries] = useState<OptionItemType[]>([])
  const [dispatchType, setDispatchType] = useState<OptionItemType[]>([])
  const [departments, setDepartments] = useState<OptionItemType[]>([])
  const [countryCode, setCountryCode] = useState("")
  const {
    dataSourceSelected,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isHiddenBtnScheduleDraft,
    isHiddenBtnTravelerDraft,
    onChange,
    onChangeTable,
    perItem,
    rowSelection,
    selectedRowKeys,
    travelerId,
  } = useRowSelection(travelerInfo)
  const {
    handleExportFile,
    isLoading,
    isOpen,
    onCancel,
    onOpen,
    push,
    setIsLoading,
  } = useExportFile({ dataSourceExport, selectedRowKeys })
  const {
    goToSchedulesAdd,
    goToSchedulesAddDraft,
    goToTravelersDelete,
    goToTravelersDetail,
    goToTravelersEditDraft,
  } = useTravelersRouters({
    dataSourceSelected,
    pathname,
    searchCondition,
    state,
    travelerId,
  })
  const breadcrumbItems = getBreadcrumbItems(pathname)
  // APIを呼び出し、「都市」コンボボックスの表示一覧を取得する。
  const { cities, setCities } = getCities(countryCode)

  return {
    allCountries,
    breadcrumbItems,
    cities,
    columns,
    countryCode,
    departments,
    dispatchType,
    form,
    goToSchedulesAdd,
    goToSchedulesAddDraft,
    goToTravelersDelete,
    goToTravelersDetail,
    goToTravelersEditDraft,
    handleExportFile,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isHiddenBtnDelete,
    isHiddenBtnExportFile,
    isHiddenBtnRefer,
    isHiddenBtnRegister,
    isHiddenBtnRequestDelete,
    isHiddenBtnScheduleDraft,
    isHiddenBtnTravelerDraft,
    isLoading,
    isLoadingLayout,
    isNotAccessScreen,
    isOpen,
    isOtherCity,
    isOverseasResident,
    isPathnameTravelers,
    isPathnameTravelersUser,
    isPathnameTravelersUserSearch,
    onCancel,
    onChange,
    onChangeTable,
    onOpen,
    pathname,
    perItem,
    push,
    rowSelection,
    setAllCountries,
    setCities,
    setCountryCode,
    setDataSourceExport,
    setDepartments,
    setDispatchType,
    setIsLoading,
    setIsLoadingLayout,
    setIsOtherCity,
    setIsOverseasResident,
    setSearchCondition,
    setTravelerInfo,
    state,
    travelerInfo,
  }
}
